var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "384px",
    height: "384px",
    viewBox: "0 0 384 384",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right_arrow",
    fill: "#7A5020",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192,384 C217.213867,384 242.180267,379.0336 265.476267,369.384533 C288.770133,359.735467 309.934933,345.5936 327.765333,327.765333 C345.5936,309.934933 359.735467,288.770133 369.384533,265.476267 C379.0336,242.180267 384,217.213867 384,192 C384,166.786133 379.0336,141.819307 369.384533,118.5248 C359.735467,95.2302933 345.5936,74.0644267 327.765333,56.23552 C309.934933,38.4066133 288.770133,24.2641067 265.476267,14.61504 C242.180267,4.96618667 217.213867,0 192,0 C141.0784,0 92.24256,20.22848 56.23552,56.23552 C20.22848,92.24256 0,141.0784 0,192 C0,242.920533 20.22848,291.7568 56.23552,327.765333 C92.24256,363.771733 141.0784,384 192,384 Z M155.584,143.082667 C153.546667,141.114667 151.921067,138.760747 150.8032,136.157867 C149.685333,133.5552 149.096533,130.75584 149.07045,127.9232 C149.047467,125.09056 149.5872,122.281387 150.660267,119.659733 C151.733333,117.037867 153.316267,114.656 155.319467,112.653013 C157.322667,110.649813 159.703467,109.065813 162.325333,107.993173 C164.9472,106.920533 167.7568,106.3808 170.589867,106.403783 C173.422933,106.429867 176.221867,107.018453 178.824533,108.136533 C181.4272,109.254613 183.7824,110.879787 185.749333,112.917333 L249.749333,176.917333 C253.749333,180.917333 255.995733,186.3424 255.995733,192 C255.995733,197.6576 253.749333,203.082667 249.749333,207.082667 L185.749333,271.082667 C181.725867,274.9696 176.337067,277.12 170.743467,277.07255 C165.149867,277.021867 159.799467,274.7776 155.844267,270.8224 C151.889067,266.8672 149.6448,261.5168 149.595733,255.9232 C149.546667,250.3296 151.697067,244.9408 155.584,240.917333 L204.501333,192 L155.584,143.082667 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.3a43edde3640ff4fe6b0d329e6a7c5c4.svg";
export { ForwardRef as ReactComponent };